module.exports = __webpack_public_path__ + "img/Lazada.9e43dffb.jpg";